import React, { useState } from 'react';
import { useCharbeePlanId, usePrerenderUser } from '../../hooks/usePrerenderUser';
import { useEvent } from '../events/hooks/useEvent';
import { NewClearCacheModal } from './NewClearCacheModal';
import useFeatureFlag, { FeatureFlag } from '../../hooks/useFeatureFlag';
import ButtonWithRole from '../../components/ButtonWithRole';
import { CONTENT_WRITE_REFUSED_ROLES } from '../auth/roleCapabilities';

export const NewClearCacheCard = () => {
  const { track } = useEvent();
  const chargebeePlanId = useCharbeePlanId();
  const [openClearCacheModal, setOpenClearCacheModal] = useState(false);
  const prerenderUser = usePrerenderUser();

  const isClearCacheDisabled = useFeatureFlag([FeatureFlag.DisableClearCache]);

  return (
    <>
      {!isClearCacheDisabled && (
        <>
          <NewClearCacheModal open={openClearCacheModal} onClose={() => setOpenClearCacheModal(false)} />
          {prerenderUser.isMeteredBilling && (
            <ButtonWithRole
              disabledFor={CONTENT_WRITE_REFUSED_ROLES}
              onClick={() => {
                track('Clear Cache Clicked', { subscription_plan: chargebeePlanId });
                setOpenClearCacheModal(true);
              }}
            >
              Clear Cache
            </ButtonWithRole>
          )}
        </>
      )}
    </>
  );
};
